import { clearUserData } from "globalResources/util";
import jsCookie from "js-cookie";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import styled from "styled-components";

const Main = styled.div`
  display: flex;
  flex-direction: column;
`;

const HandleLoginLink = () => {
  const { token } = useParams();
  const { search } = useLocation();
  const reportId = new URLSearchParams(search).get("reportId");
  const dispatch = useDispatch();

  useEffect(() => {
    async function setToken() {
      clearUserData(dispatch);

      setTimeout(() => {
        jsCookie.set("token", token);
        if (reportId) window.location.replace(`/accounting/report/${reportId}`);
        // onboarding sends new people on to set a password and pick a
        // company, and everyone else straight to the dashboard
        else window.location.replace("/onboarding");
      }, 1000);
    }
    setToken();
  }, [token]);

  return <Main>Loggin you in...</Main>;
};
export default HandleLoginLink;
